import { Component } from '@angular/core';
import {AlertController, Events, IonicPage, NavController, NavParams} from 'ionic-angular';
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {ApiUserProgressProvider} from "../../providers/api-user-progress/api-user-progress";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppStatsPage} from "../app-stats/app-stats";
import {AppMoodTrackerPage} from "../app-mood-tracker/app-mood-tracker";
import {AppStatsIntroPage} from "../app-stats-intro/app-stats-intro";
import {AppChallengeUserPage} from "../app-challenge-user/app-challenge-user";
import {AppStatsFoodPage} from "../app-stats-food/app-stats-food";

/**
 * Generated class for the DebugPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-debug',
  templateUrl: 'debug.html',
})
export class DebugPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private event: Events,
    private userProgressProvider: ApiUserProgressProvider,
    private alertCtrl: AlertController,
    private contentTranslation: ContentTranslationProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DebugPage');
    (window as any).iEvent = this.event;
    (window as any).debugController = this;


    setTimeout(() => {
      this.navCtrl.push(AppStatsFoodPage)
    }, 1000);

  }

  normalStart() {
    this.navCtrl.setRoot(AppDashboardPage);
  }

  showLastStagePopup() {
    this.userProgressProvider.showLastModuleEndPopup();
  }
  showModuleClosedPopup(num) {
    const alert = this.alertCtrl.create({
      title: '<img src="/assets/imgs/popup-success-icon-'+num+'.png" />'+this.contentTranslation.translateContent('Stage closed title'),
      subTitle: this.contentTranslation.translateContent('Stage %num% closed content. New stage available in %days%').replace('%num%', num.toString()).replace('%days%', num),
      buttons: [
        {
          text: this.contentTranslation.translateContent('WEITER GEHT`S'),
          handler: _ => {
          }
        }

      ],
      cssClass: 'ip-alert ip-with-close ip-stage-completed-popup ip-normal-stage-completed-popup'
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/debug/debug.ts